module.exports = __webpack_public_path__ + "img/arrow-up.560e7d7a.svg";